export enum CommunicationType {
    Unknown = 0,
    Email = 1,
    SMS = 2,
    PushNotification = 3,
    PopUpNotification = 4,
    InternalMessage = 5,
    Telegram = 6,
    Bonus = 7,
    CMSPopUpNotification = 8,
    Viber = 9,
    Hoory = 10,
    FastexNotification = 11,
    DynamicPopUp = 12,
    YoPhone = 13,
}

export enum CommunicationStatus {
    Succeeded = 0,
    Failed = 1,
    Pending = 2,
    Queued = 3,
    Skipped = 4,
}
